import { createContext, useContext } from 'react';

export const BrandingContext = createContext({
  appName: 'KTC ISP Platform',
  logoUrl: null,
  primaryColor: '#0ea5e9',
  secondaryColor: '#22d3ee',
  themeMode: 'dark',
  refreshBranding: async () => {},
});

export const useBranding = () => useContext(BrandingContext);

